import {isEmpty, uniqBy, trim} from 'lodash';
import { parse } from 'node-html-parser';
import url from 'url';

const INTERNAL_HOSTNAME_REGEX = /refinery29\.(com|uk|de)|\.rf29\.net/; // eslint-disable-line no-useless-escape

/* content must be a String of HTML */
export const external_links = (content) => {
  const root = parse(content);
  const A = root.querySelectorAll('a[href]');

  for (let i = 0, l = A.length; i < l; i++) {
    const a = A[i];
    const href = url.parse(a.getAttribute('href'));
    const domain = (href.host || '').replace(/^www./, '');
    if (href.protocol === 'http:' || href.protocol === 'https:') {
      if (domain.match(INTERNAL_HOSTNAME_REGEX) !== null) { // Proper internal link formatting
        // Remove un-needed `target="_blank"` from internal links
        a.removeAttribute('target');
        // Enforce HTTPS on internal links
        href.protocol = 'https:';
        a.setAttribute('href', url.format(href));
      } else if (
        (a.getAttribute('target') === '_blank') ||
        domain.match(INTERNAL_HOSTNAME_REGEX) === null
      ) { // Add proper `rel` values to external links
        let rel = a.getAttribute('rel');
        if (isEmpty(rel)) {
          a.setAttribute('rel', 'noopener noreferrer nofollow');
        } else if (typeof rel === 'string') {
          /*
           * If rel already exists assume nofollow may be set
           *  Don't want to add a nofollow where not requested
           */
          rel = (rel + '').split(' ');
          rel = uniqBy(rel.concat(['noopener', 'noreferrer']));
          a.setAttribute('rel', Array.from(rel).join(' '));
        }

        // Force it if it isn't there as we've ensured it's already external
        a.setAttribute('target', '_blank');
      }
    }
  }

  return root.toString();
};

const is_link_external = (link) => {
  if (typeof link !== 'string') {
    return false;
  }
  const href = url.parse(link);
  const domain = (href.host || '').replace(/^www./, '');
  if (href.protocol === 'http:' || href.protocol === 'https:') {
    if (domain.match(INTERNAL_HOSTNAME_REGEX) !== null) {
      return false;
    }
  }
  return true;
};

export const link_target = (link) => {
  if (!is_link_external(link)) {
    return null;
  }
  return '_blank';
};

export const link_rel = (link, rel) => {
  if (!is_link_external(link)) {
    if (!rel || isEmpty(rel)) {
      return null;
    }

    return trim(rel);
  }

  if (!rel || isEmpty(rel)) {
    return 'noopener noreferrer nofollow';
  }

  rel = (rel + '').split(' ');
  rel = uniqBy(rel.concat(['noopener', 'noreferrer', 'nofollow']));
  return trim(Array.from(rel).join(' '));
};
